import { render, staticRenderFns } from "./CustomerFees.vue?vue&type=template&id=0d88dcf8&scoped=true"
import script from "./CustomerFees.vue?vue&type=script&lang=js"
export * from "./CustomerFees.vue?vue&type=script&lang=js"
import style0 from "./CustomerFees.vue?vue&type=style&index=0&id=0d88dcf8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d88dcf8",
  null
  
)

export default component.exports